export default __webpack_public_path__ + "static/media/onboarding-welcome.5a6d73ef.png";